import { addHttpsIfNeeded } from '@helpers/url'
import { Button, CustomLink, Spacer, Spreader, Text } from '@ui-kit'
import { Fragment } from 'react'
import { Column, Row } from 'simple-flexbox'

import styles from './Fields.module.scss'

export const WebsiteField = ({
  label,
  value
}: {
  label: string
  value: string
}) => {
  const href = addHttpsIfNeeded(value)

  const handleOpenLink = () => {
    window.open(href, '_blank')
  }

  return (
    <Column>
      <div className={styles.label}>
        <Text size={14} color='neutral-6' lineHeight='normal'>
          {label}
        </Text>
      </div>

      <Row className={styles.field} alignItems='center'>
        {value ? (
          <Fragment>
            <CustomLink
              href={href}
              target='_blank'
              onClick={e => e.stopPropagation()}
              size={16}
              className={styles.linkValue}
            >
              {value}
            </CustomLink>

            <Spreader spread={20} />

            <Button
              icon='icon-external-link-alt'
              variant='text-neutral'
              className={styles.button}
              onClick={handleOpenLink}
            />
          </Fragment>
        ) : (
          '-'
        )}
      </Row>
      <Spacer space={10} />
    </Column>
  )
}
